import { h } from 'preact';
import Page from 'components/pages/page';
import { Link } from 'components/core/link/link.js';
import HTML from 'components/core/html/html.js';
import s from 'components/pages/partners/partners.sss';
import { sortObjectByOrder } from 'utils/utils';

export default class partners extends Page {

	constructor(...args) {
		super(...args);
		this.renderImage = this.renderImage.bind(this);
	}

	renderImage(image) {
		if (!image) return;
		return (
			<Link class={s.link} href={image.link} target="_blank" trackId={image.track} renderCustomChild>
				<div class={s.imageContainer}>
					<img class={`${s.image} ${s[image.id]}`} src={image.image} alt={image.imageAlt} />
					{ image.text && <p class={s.text}>{image.text}</p>}
				</div>
			</Link>
		);
	}

	renderTitle() {
		let pageData = this.props.pageData;
		let titleContent = pageData.title;
		if (!titleContent) {
			return;
		}
		titleContent = this.props.appData.copy[titleContent] || titleContent;
		return <HTML tag="h1" class={s.title} content={titleContent} markdown />;
	}

	render(props) {
		let images = props.pageData.images;
		const src = props.pageData.tt;
		const copy = props.appData.copy;
		const alt = copy.$SYNOPSIS_ALT_TITLE || copy.$TITLE;
		const { pageTitle } = props.pageData;
		const title = pageTitle;

		return (
			<div class={s.wrapper}>
				<img alt={alt} class={s.tt} src={src} />
				<HTML tag="h2" class={s.title} markdown>{title}</HTML>
				{sortObjectByOrder(images, this.renderImage)}
			</div>
		);
	}

}

export const verticallyCenter = true;
